// =============================================
// 🎮 FloatKeyGames — Routes
// =============================================
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./FloatBlock/ScrollToTop";

// 🆕 Páginas adicionales
import FloatBlock from "./FloatBlock/FloatBlock";
import TermsandConditionsFB from "./FloatBlock/TermsandConditionsFB";
import PrivacyPolicyFB from "./FloatBlock/PrivacyPolicyFB";
import MainPage from "./MainPage/MainPage";

export default function App() {
  return (
    <BrowserRouter>
        <ScrollToTop />
        {/* 🏠 Página principal */}
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/home" element={<MainPage />} />

          {/* 🎮 Página individual de Float Block */}
          <Route path="/floatblock" element={<FloatBlock />} />
          <Route path="/termsandconditions" element={<TermsandConditionsFB />} />
          <Route path="/privacypolicy" element={<PrivacyPolicyFB />} />
      </Routes>
    </BrowserRouter>
  );
}
